import eventsApi from 'api/requests/events'
import Button from 'components/_UI/Button'
import Loader from 'components/_UI/Loader'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import { useEvent } from 'context/events/Event'
import { useCollapse } from 'context/general/Collapse'
import React, { useState } from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import buttonText from 'texts/buttons/buttonText'

export default function DeleteEvent({ isOpen, setIsOpen }) {
    const { event, setEvent } = useEvent();
    const { collapse, setCollapse } = useCollapse();

    const [loading, setLoading] = useState(false);
    const [deleted, setDeleted] = useState(false);

    async function deleteEvent() {
        setLoading(true)
        try {
            await eventsApi.delete(event.slug)
            setDeleted(true)
            setEvent(null)
            setCollapse({
                ...collapse,
                withContent: false,
                height: '280px',
                arrowPosition: true,
                componentToRender: false
            })
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
            {
                deleted ? (
                    <Column fullyCentralized>
                        <Text marginTop='30px' name='subtitle'> Evento deletado com sucesso. </Text>
                        <Column width='200px' marginTop='10px'>
                            <Button onClick={() => setIsOpen(false)}>
                                {buttonText.ok}
                            </Button>
                        </Column>
                    </Column>
                ) :
                    loading
                        ? <Loader />
                        : (
                            <Column fullyCentralized>
                                <Text marginTop='30px' name='subtitle'> Tem certeza que deseja excluir o evento {event?.name}? </Text>
                                <Row marginTop='30px'>
                                    <Button
                                        variant='secondary'
                                        marginRight='15px' onClick={() => setIsOpen(false)}
                                    >
                                        {buttonText.cancel}
                                    </Button>

                                    <Button
                                        onClick={() => deleteEvent()}
                                    >
                                        {buttonText.confirm}
                                    </Button>
                                </Row>
                            </Column>
                        )
            }
        </Modal>
    )
}
